import { Button, DatePicker, Form, Row, Space } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubsidiaries } from '../../../../appRedux/actions';
import { getDailySales } from '../../../../appRedux/actions/Reports';
import { buttonLabel, formConfig, placeHolders } from '../../../../constants';
import { CustomSelect } from '../../../uiComponents';

export const DailySalesFilter = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { subsidiaries } = useSelector((state) => state.subsidiary);

  useEffect(() => {
    dispatch(getSubsidiaries({ status: 1 }));
  }, [dispatch]);

  const onSubmit = (values) => {
    if (values?.month) {
      values.month = moment(values?.month).format('YYYY-MM');
    }
    dispatch(getDailySales(values));
  };

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="month">
            <DatePicker picker="month" format={'YYYY-MM'} />
          </Form.Item>
          <Form.Item name="branchId">
            <CustomSelect
              placeholder={placeHolders.branch}
              style={{ minWidth: '200px' }}
              options={subsidiaries?.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
            ></CustomSelect>
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
